import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';

import { StoreService } from 'shared/services/store.service';

@Component({
  selector: 'app-close-offer',
  templateUrl: './close-offer.component.html',
  styleUrls: ['./close-offer.component.scss']
})
export class CloseOfferComponent implements OnInit {
  form!: UntypedFormGroup;

  constructor(
    protected fb: UntypedFormBuilder,
    private storeService: StoreService,
  ) { }

  ngOnInit(): void {
    this.init();
  }

  private init(): void {
    this.form = this.fb.group({
      confirmCloseOffer: true
    });

    setTimeout(() => {
      this.form.updateValueAndValidity({ emitEvent: true });
    }, 0);

    this.storeService.setFormReady(true);
  }

  setPending(_val: boolean): void {
    this.form.disable();
    (this.form.statusChanges as any).emit('INVALID');
  }
}
